import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import Join from "@/pages/Join";
import JoinReturn from "@/pages/JoinReturn";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Learn from "@/pages/Learn";
import Lesson from "@/pages/Lesson";
import Journal from "@/pages/Journal";
import ChartMentor from "@/pages/ChartMentor";
import CoachDesk from "@/pages/CoachDesk";
import Intelligence from "@/pages/Intelligence";
import Community from "@/pages/Community";
import CheckoutReturn from "@/pages/CheckoutReturn";
import Legal from "@/pages/Legal";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/join/return" element={<JoinReturn />} />
            <Route path="/join/:planId" element={<Join />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/checkout/return" element={<CheckoutReturn />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/intelligence" element={<Intelligence />} />
            <Route
              path="/community"
              element={
                <ProtectedRoute>
                  <Community />
                </ProtectedRoute>
              }
            />
            <Route
              path="/learn"
              element={
                <ProtectedRoute>
                  <Learn />
                </ProtectedRoute>
              }
            />
            <Route
              path="/learn/lesson/:id"
              element={
                <ProtectedRoute>
                  <Lesson />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mentor"
              element={
                <ProtectedRoute>
                  <ChartMentor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/journal"
              element={
                <ProtectedRoute>
                  <Journal />
                </ProtectedRoute>
              }
            />
            <Route
              path="/desk"
              element={
                <ProtectedRoute allow={["super_admin", "admin", "coach", "content_editor"]}>
                  <CoachDesk />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allow={["super_admin", "admin", "content_editor"]}>
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
